import { ButtonV3, theme, showToast } from '@provi/provi-components'
import React, { useContext, useState } from 'react'

import { IconDownload } from '../../../../assets/svg/icon-download'
import { Hr } from '../../../../components/horizontal-row'
import { TemplateContext } from '../../../../components/template/context'
import { currencyParser } from '../../../../utils'

import {
  Br,
  ItemInvoice,
  Left,
  Text,
  Footer,
  TextTitle,
  TextSimple,
  Right,
  Status,
  Header,
  TextButton,
  InformationText,
  Center,
  PaymentSection,
  PixSection,
  PixLabel,
  PixQRCode,
  PixCopyButton,
  EntryCard,
  EntryRow,
  EntryLabel,
  EntryValue,
  EntrySubLabel,
  EntrySubValue,
  AlternativePayment,
  AlternativeText,
  AlternativeActions,
  AlternativeLink
} from './styles'

const formatDate = dateString => {
  if (!dateString) return '-'
  if (dateString.includes('/')) return dateString
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return dateString
  return new Intl.DateTimeFormat('pt-BR').format(date)
}

const copyToClipboard = async text => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      return true
    } finally {
      document.body.removeChild(textArea)
    }
  }
}

export const CardAvailable = ({ item, getInvoice, renegotiation }) => {
  const { isMobile } = useContext(TemplateContext)
  const [isCopying, setIsCopying] = useState(false)

  const paymentData = renegotiation?.payment || item?.renegotiation?.payment
  const hasPaymentData =
    paymentData && (paymentData.boleto || paymentData.pixQrCode || paymentData.pixQrCodeText || paymentData.barCode)

  const handleCopyPix = async () => {
    if (!paymentData?.pixQrCodeText) return

    setIsCopying(true)
    try {
      await copyToClipboard(paymentData.pixQrCodeText)
      showToast('Código PIX copiado!', 'success')
    } catch (err) {
      showToast('Erro ao copiar código PIX')
    } finally {
      setIsCopying(false)
    }
  }

  const handleCopyBarcode = async () => {
    if (!paymentData?.barCode) return

    setIsCopying(true)
    try {
      await copyToClipboard(paymentData.barCode)
      showToast('Código de barras copiado!', 'success')
    } catch (err) {
      showToast('Erro ao copiar código de barras')
    } finally {
      setIsCopying(false)
    }
  }

  return (
    <ItemInvoice>
      <Header>
        <Left>
          <TextTitle>{currencyParser(item.price || 0, 'R$')}</TextTitle>
          <TextSimple>Vencimento: {item.date}</TextSimple>
        </Left>
        <Right>
          <Text>Fatura aberta</Text>
          <Status color={theme.colors.yellow900} />
        </Right>
      </Header>
      {/* Botão "Pagar agora" só aparece quando NÃO houver dados de pagamento */}
      {!hasPaymentData && (
        <Footer>
          <Left>
            {isMobile ? (
              <ButtonV3 onClick={() => getInvoice(item)}>
                <TextButton>Pagar agora</TextButton>
                {!isMobile && <IconDownload />}
              </ButtonV3>
            ) : (
              <ButtonV3
                color="light"
                marginVertical={0}
                marginHorizontal={0}
                onClick={() => getInvoice(item)}
                text="Pagar agora"
              />
            )}
          </Left>
          <Right>
            <Text>{item.isUpfront ? 'Entrada' : `${item.number}/${item.amountOfItems}`}</Text>
          </Right>
        </Footer>
      )}
      {item?.renegotiationInvoice && (
        <Center>
          <Hr />
          <InformationText>
            • Essa fatura deve ser paga para efetivar a renegociação do financiamento <Br />
            • Não é possível gerar uma segunda via dessa fatura
            <Br />
          </InformationText>
        </Center>
      )}

      {/* Estrutura de pagamento - só aparece quando houver renegotiation.payment */}
      {hasPaymentData && (
        <PaymentSection>
          <PixSection>
            <PixLabel>Pagar entrada com PIX</PixLabel>
            <PixQRCode>
              {paymentData.pixQrCode ? (
                <img src={paymentData.pixQrCode} alt="QR Code PIX" />
              ) : (
                <svg width="202" height="202" viewBox="0 0 202 202" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="202" height="202" fill="#F4F4F5" />
                  <rect x="25" y="25" width="50" height="50" fill="black" />
                  <rect x="127" y="25" width="50" height="50" fill="black" />
                  <rect x="25" y="127" width="50" height="50" fill="black" />
                  <rect x="127" y="127" width="50" height="50" fill="black" />
                  <rect x="88" y="88" width="26" height="26" fill="black" />
                  <rect x="76" y="51" width="26" height="26" fill="black" />
                  <rect x="101" y="127" width="26" height="26" fill="black" />
                </svg>
              )}
            </PixQRCode>
            <PixCopyButton onClick={handleCopyPix} disabled={isCopying || !paymentData.pixQrCodeText}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_pix)">
                  <path
                    d="M5.83333 5.00008V2.50008C5.83333 2.27907 5.92113 2.06711 6.07741 1.91083C6.23369 1.75455 6.44565 1.66675 6.66667 1.66675H16.6667C16.8877 1.66675 17.0996 1.75455 17.2559 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V14.1667C17.5 14.3878 17.4122 14.5997 17.2559 14.756C17.0996 14.9123 16.8877 15.0001 16.6667 15.0001H14.1667V17.5001C14.1667 17.9601 13.7917 18.3334 13.3275 18.3334H3.33917C3.22927 18.3341 3.12033 18.313 3.0186 18.2714C2.91687 18.2299 2.82436 18.1686 2.74638 18.0912C2.6684 18.0137 2.60649 17.9216 2.56421 17.8202C2.52193 17.7188 2.50011 17.61 2.5 17.5001L2.5025 5.83342C2.5025 5.37341 2.8775 5.00008 3.34167 5.00008H5.83333ZM4.16917 6.66675L4.16667 16.6667H12.5V6.66675H4.16917ZM7.5 5.00008H14.1667V13.3334H15.8333V3.33341H7.5V5.00008Z"
                    fill="#0273FF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_pix">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {isCopying ? 'Copiando...' : 'Copiar código PIX'}
            </PixCopyButton>
          </PixSection>

          <EntryCard>
            <EntryRow>
              <EntryLabel>Valor da entrada</EntryLabel>
              <EntryValue>{currencyParser(parseFloat(paymentData.amount || 0), 'R$')}</EntryValue>
            </EntryRow>
            <EntryRow>
              <EntrySubLabel>Venc. da entrada</EntrySubLabel>
              <EntrySubValue>{formatDate(paymentData.dueDate)}</EntrySubValue>
            </EntryRow>
          </EntryCard>

          <AlternativePayment>
            <AlternativeText>Você também pode pagar a entrada com boleto</AlternativeText>
            <AlternativeActions>
              <AlternativeLink href={paymentData.boleto || '#'} target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.0002 2.5C14.4935 2.5 18.2319 5.73333 19.016 10C18.2327 14.2667 14.4935 17.5 10.0002 17.5C5.50687 17.5 1.76854 14.2667 0.984375 10C1.76771 5.73333 5.50687 2.5 10.0002 2.5ZM10.0002 15.8333C11.6998 15.833 13.3489 15.2557 14.6776 14.196C16.0063 13.1363 16.936 11.6569 17.3144 10C16.9346 8.34442 16.0043 6.86667 14.6757 5.80835C13.3471 4.75004 11.6988 4.17377 10.0002 4.17377C8.30162 4.17377 6.65328 4.75004 5.32469 5.80835C3.99609 6.86667 3.06585 8.34442 2.68604 10C3.06446 11.6569 3.9941 13.1363 5.32283 14.196C6.65155 15.2557 8.30065 15.833 10.0002 15.8333ZM10.0002 13.75C9.00565 13.75 8.05182 13.3549 7.34856 12.6516C6.6453 11.9484 6.25021 10.9946 6.25021 10C6.25021 9.00544 6.6453 8.05161 7.34856 7.34835C8.05182 6.64509 9.00565 6.25 10.0002 6.25C10.9948 6.25 11.9486 6.64509 12.6519 7.34835C13.3551 8.05161 13.7502 9.00544 13.7502 10C13.7502 10.9946 13.3551 11.9484 12.6519 12.6516C11.9486 13.3549 10.9948 13.75 10.0002 13.75ZM10.0002 12.0833C10.5527 12.0833 11.0826 11.8638 11.4733 11.4731C11.864 11.0824 12.0835 10.5525 12.0835 10C12.0835 9.44747 11.864 8.91756 11.4733 8.52686C11.0826 8.13616 10.5527 7.91667 10.0002 7.91667C9.44767 7.91667 8.91777 8.13616 8.52707 8.52686C8.13637 8.91756 7.91687 9.44747 7.91687 10C7.91687 10.5525 8.13637 11.0824 8.52707 11.4731C8.91777 11.8638 9.44767 12.0833 10.0002 12.0833Z"
                    fill="#0273FF"
                  />
                </svg>
                Visualizar fatura
              </AlternativeLink>
              <AlternativeLink
                href="#"
                onClick={e => {
                  e.preventDefault()
                  handleCopyBarcode()
                }}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_barcode)">
                    <path
                      d="M5.83333 5.00008V2.50008C5.83333 2.27907 5.92113 2.06711 6.07741 1.91083C6.23369 1.75455 6.44565 1.66675 6.66667 1.66675H16.6667C16.8877 1.66675 17.0996 1.75455 17.2559 1.91083C17.4122 2.06711 17.5 2.27907 17.5 2.50008V14.1667C17.5 14.3878 17.4122 14.5997 17.2559 14.756C17.0996 14.9123 16.8877 15.0001 16.6667 15.0001H14.1667V17.5001C14.1667 17.9601 13.7917 18.3334 13.3275 18.3334H3.33917C3.22927 18.3341 3.12033 18.313 3.0186 18.2714C2.91687 18.2299 2.82436 18.1686 2.74638 18.0912C2.6684 18.0137 2.60649 17.9216 2.56421 17.8202C2.52193 17.7188 2.50011 17.61 2.5 17.5001L2.5025 5.83342C2.5025 5.37341 2.8775 5.00008 3.34167 5.00008H5.83333ZM4.16917 6.66675L4.16667 16.6667H12.5V6.66675H4.16917ZM7.5 5.00008H14.1667V13.3334H15.8333V3.33341H7.5V5.00008Z"
                      fill="#0273FF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_barcode">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {isCopying ? 'Copiando...' : 'Copiar código de barras'}
              </AlternativeLink>
            </AlternativeActions>
          </AlternativePayment>
        </PaymentSection>
      )}
    </ItemInvoice>
  )
}
